import {Picker} from 'pickers/picker';

class TitleCodePicker extends Picker {
  get strings() { return {
    ...super.strings,
    placeholder: 'Type a title code',
  }}
}
TitleCodePicker.watch('select.title-code-picker');
